import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectorSystemOnLine } from "../store/system/selectors";

export const useIsFontsLoaded = () => {
  const onLine = useSelector(selectorSystemOnLine);

  const [isFontsLoaded, setIsFontsLoaded] = useState(!onLine);

  useEffect(() => {
    let timerId;
    const onLoadingDone = () => {
      clearTimeout(timerId);
      setIsFontsLoaded(true);
      global.window?.document?.fonts?.removeEventListener("loadingdone", onLoadingDone);
    };

    if (!global.window?.document?.fonts?.status || !onLine) {
      onLoadingDone(true);
    } else {
      if (global.window.document.fonts.status === "loaded") {
        onLoadingDone();
      } else {
        global.window.document.fonts.addEventListener("loadingdone", onLoadingDone);

        // Show UI after 2 seconds anyway.
        timerId = setTimeout(() => {
          onLoadingDone(true);
        }, 2000);
      }
    }

    return () => {
      clearTimeout(timerId);
      global.window.document.fonts.removeEventListener("loadingdone", onLoadingDone);
    };
  }, [onLine]);

  return isFontsLoaded;
};

export const withIsFontsLoaded = (Component) => {
  return (props) => {
    const isFontsLoaded = useIsFontsLoaded();
    return <Component isFontsLoaded={isFontsLoaded} {...props} />;
  };
};
